const appConfig = {
  "name": "frc-v2",
  "version": "0.1.0",
  "stage": "prod",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
    "clientId": "308arstgj1rej4vdpcd6lsa759",
    "redirectUris": [
      "https://frc.mit.edu",
      "https://frc.atlas-apps.mit.edu",
      "https://frc-mr.atlas-apps.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://frc.mit.edu/logout",
      "https://frc.atlas-apps.mit.edu/logout",
      "https://frc-mr.atlas-apps.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/user",
      "email",
      "offline_access",
      "openid",
      "phone",
      "profile",
      "user/finance"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_bCu6BU8d2",
    "userPoolWebClientId": "308arstgj1rej4vdpcd6lsa759",
    "oauth": {
      "domain": "atlas-auth.mit.edu",
      "scope": [
        "digital-id/user",
        "openid",
        "profile",
        "system/finance",
        "user/all",
        "user/finance"
      ],
      "redirectUris": [
        "https://frc.mit.edu",
        "https://frc.atlas-apps.mit.edu",
        "https://frc-mr.atlas-apps.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://frc.mit.edu/logout",
        "https://frc.atlas-apps.mit.edu/logout",
        "https://frc-mr.atlas-apps.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;